const {
    REACT_APP_ROOT_PATH
  } = process.env;
  
  const ROOT_API_URL = REACT_APP_ROOT_PATH;
  
  export {
    ROOT_API_URL,
  }